module.exports = __webpack_public_path__ + "static/media/logo-adene.e8db3c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RatingHeader/logo-adene.png
// module id = 1676
// module chunks = 0